export default "__VITE_ASSET__d5e763e6__"